<template>
  <section class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>
        <AnimatedGradientText>{{ t('label_name') }}</AnimatedGradientText>
      </h3>
      <h4 class="medium">
        <AnimationTyping :text="t('onboarding_placeholder_nickname')" />
      </h4>
    </div>
    <input
      :value="form.nickname"
      :placeholder="t('onboarding_placeholder_scon_guitar')"
      @input="handleNickname"
      class="fadeinOnboarding"
    />
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import AnimatedGradientText from '@/components/shared/base/AnimatedGradientText.vue';
import { ISelfServiceOnboardingForm } from '@/types/components';

const { t } = useI18n();

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

const handleNickname = (e) => {
  form.value.nickname = e.target.value;
};
</script>

<style scoped></style>
